<template>
  <div>
    <v-header class="header" v-if="showHeader"></v-header>
    <v-headers class="headers" v-if="showHeader"></v-headers>
    <router-view></router-view>
    <v-footer></v-footer>
  </div>
</template>

<script>
import Header from '@/components/header.vue'
import Headers from '@/components/herders.vue'
import Footer from '@/components/footer.vue'
// let isBosyuu = false;
export default {
  name: '',

  components: {
    'v-footer': Footer,
    'v-header': Header,
    'v-headers': Headers,
  },
  data: () => ({
    isBosyuu: false,
  }),
  created() { },
  mounted() { },
  watch: {},
  computed: {
    // comicsState() {
    //   return this.$store.state.comicsState;
    // },
    showHeader() {
      const path = this.$route.path;
      return !(
        path === '/help' ||
        path === '/help/' ||
        path === '/help/list' ||
        path === '/help/list/'
      );
    }
  },
  beforeRouteUpdate(to, from, next) {
    // ...
    this.isBosyuu = to.fullPath === '/bosyuu' ? true : false
    next()
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.header {
  @media screen and (max-width: 600px) {
    display: none;
  }
}

.headers {
  display: none;

  @media screen and (max-width: 600px) {
    display: block;
  }
}
</style>
